import instance from "../services";
import { JOIN_INFO_URL } from "../../utils/urls";

export const joinUser = async (submitData, files) => {
    try {
        // FormData 생성
        const formData = new FormData();
        
        // 기본 데이터 추가
        Object.keys(submitData).forEach(key => {
            // files 객체는 제외하고 처리
            if (key !== 'files' && submitData[key] !== undefined && submitData[key] !== null) {
                formData.append(key, submitData[key]);
            }
        });

        // 파일 추가
        if (submitData.member_kind === "corporate") {
            // 사업자 회원가입: 신분증 + 사업자등록증
            if (files.identification_img) {
                formData.append('identification_img', files.identification_img);
            }
            if (files.business_registration_img) {
                formData.append('business_registration_img', files.business_registration_img);
            }
        } else {
            // 개인 회원가입
            if (submitData.mem_type === "1" || submitData.mem_type === "3") {
                // 일반회원, 촬영감독: 신분증만
                if (files.identification_img) {
                    formData.append('identification_img', files.identification_img);
                }
            } else if (submitData.mem_type === "2") {
                // 학생: 신분증 + 학생증
                if (files.identification_img) {
                    formData.append('identification_img', files.identification_img);
                }
                if (files.student_id_img) {
                    formData.append('student_id_img', files.student_id_img);
                }
            } else if (submitData.mem_type === "4") {
                // 제작사: 신분증 + 사업자등록증
                if (files.identification_img) {
                    formData.append('identification_img', files.identification_img);
                }
                if (files.business_registration_img) {
                    formData.append('business_registration_img', files.business_registration_img);
                }
            }
        }

        // 타임아웃 시간을 30초로 늘림
        const response = await instance.post(JOIN_INFO_URL, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            timeout: 30000 // 30초로 설정
        });

        return response;
    } catch (error) {
        // 에러 로깅 개선
        console.error('회원가입 에러 상세:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
            config: {
                url: error.config?.url,
                method: error.config?.method,
                timeout: error.config?.timeout
            }
        });
        
        // 타임아웃 에러인 경우 더 명확한 메시지 전달
        if (error.code === 'ECONNABORTED') {
            error.response = {
                data: {
                    message: '서버 응답 시간이 초과되었습니다. 잠시 후 다시 시도해주세요.'
                }
            };
        }
        
        throw error;
    }
};
